"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var SUPPORT_ALIGN = ['left', 'center', 'right', 'justify'];
exports.SUPPORT_ALIGN = SUPPORT_ALIGN;
var getMarkDisable = function (excludeMarks, markName) {
    if (!excludeMarks)
        return false;
    if (excludeMarks === '_')
        return true;
    if (excludeMarks.split(/\s/).includes(markName))
        return true;
    return false;
};
exports.getMarkDisable = getMarkDisable;
var getStyleAlign = function (dom) {
    var style = dom.getAttribute('style') || '';
    var matchRes = style.match(/text-align:\s*([^;]*)/);
    if (matchRes && SUPPORT_ALIGN.includes(matchRes[1])) {
        return matchRes[1];
    }
    return undefined;
};
exports.getStyleAlign = getStyleAlign;
var checkMarkDisable = function (view, markName) {
    var $from = view.state.selection.$from;
    if ($from.parent.type.spec.code)
        return true;
    var excludeMarks = $from.parent.type.spec.excludeMarks;
    if (!getMarkDisable(excludeMarks, markName)) {
        if ($from.depth > 1) {
            var parentExcludeMarks = $from.node($from.depth - 1).type.spec.excludeMarks;
            return getMarkDisable(parentExcludeMarks, markName);
        }
        return false;
    }
    return true;
};
exports.checkMarkDisable = checkMarkDisable;
var checkParentSupportAttr = function (view, attrName) {
    return view.state.selection.$from.node().attrs[attrName] !== undefined;
};
exports.checkParentSupportAttr = checkParentSupportAttr;
var setAlign = function (view, align) {
    var state = view.state, dispatch = view.dispatch;
    var tr = state.tr;
    var ranges = state.selection.ranges;
    if (!ranges.length)
        return false;
    ranges.forEach(function (range) {
        var from = range.$from.pos;
        var to = range.$to.pos;
        state.doc.nodesBetween(from, to, function (node, nodePos) {
            if (node.isTextblock) {
                tr.setNodeMarkup(nodePos, undefined, __assign(__assign({}, node.attrs), { align: align }));
                return false;
            }
        });
    });
    dispatch(tr);
    return true;
};
exports.setAlign = setAlign;
var checkParentHaveAttr = function (view, attrName, attrVal) {
    return view.state.selection.$from.parent.attrs[attrName] === attrVal;
};
exports.checkParentHaveAttr = checkParentHaveAttr;
// 给attrs配置增加用户配置
var addAttrsByConfig = function (config, attrs) {
    if (config === void 0) { config = {}; }
    return Object.keys(config).forEach(function (name) {
        Object.keys(config[name]).forEach(function (spec) {
            if (spec === 'getFromDOM' || spec === 'setDOMAttr')
                return;
            if (!attrs[name])
                attrs[name] = {};
            attrs[name][spec] = config[name][spec];
        });
    });
};
exports.addAttrsByConfig = addAttrsByConfig;
// parseDOM时用于解析, undefined就使用默认值
var getFromDOMByConfig = function (config, dom, parseAttrs) {
    if (config === void 0) { config = {}; }
    return Object.keys(config).forEach(function (name) {
        var _a;
        var value = config[name].getFromDOM(dom);
        if (value !== undefined)
            Object.assign(parseAttrs, (_a = {}, _a[name] = value, _a));
    });
};
exports.getFromDOMByConfig = getFromDOMByConfig;
// toDOM时用于构造
var setDOMAttrByConfig = function (config, node, attrs) {
    if (config === void 0) { config = {}; }
    return Object.keys(config).forEach(function (name) { return config[name].setDOMAttr(node.attrs[name], attrs); });
};
exports.setDOMAttrByConfig = setDOMAttrByConfig;
// 保留小数点，默认保留三位小数
var getFixSize = function (num, count) {
    if (count === void 0) { count = 3; }
    return Number(num.toFixed(count).replace(/\.?0+$/, ''));
};
exports.getFixSize = getFixSize;
var createFileInput = function (_a) {
    var _b = _a.multiple, multiple = _b === void 0 ? false : _b, accept = _a.accept, onChange = _a.onChange, _c = _a.getContainer, getContainer = _c === void 0 ? function () { return document.body; } : _c;
    var input = document.createElement('input');
    input.type = 'file';
    input.multiple = multiple;
    input.accept = accept;
    input.style.display = 'none';
    input.addEventListener('change', function (e) {
        onChange(e);
        e.target.value = '';
    });
    getContainer().appendChild(input);
    return input;
};
exports.createFileInput = createFileInput;
//# sourceMappingURL=tools.js.map